<template>
    <section class="mx-auto max-w-7xl px-6 lg:px-8 pt-16 sm:pt-40">
        <div class="mx-auto max-w-2xl text-center">
            <h2 class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                {{ t('pages.home.features.title') }}
            </h2>
        </div>
        <div class="mx-auto max-w-7xl mt-16">
            <div class="grid grid-cols-2 gap-8 lg:gap-11">
                <FeatureCard imgSrc="/idx/feature_01.svg" :title="t('pages.home.features.cards.recognition.title')"
                    :description="t('pages.home.features.cards.recognition.description')" />
                <FeatureCard imgSrc="/idx/feature_02.svg" :title="t('pages.home.features.cards.complex.title')"
                    :description="t('pages.home.features.cards.complex.description')" />
                <FeatureCard imgSrc="/idx/feature_03.svg" :title="t('pages.home.features.cards.resolution.title')"
                    :description="t('pages.home.features.cards.resolution.description')" />
                <FeatureCard imgSrc="/idx/feature_04.svg" :title="t('pages.home.features.cards.interface.title')"
                    :description="t('pages.home.features.cards.interface.description')" />
            </div>
        </div>

        <div class="mt-12 w-full flex justify-center">
            <FaceSwapBtn />
        </div>
    </section>
</template>

<script setup lang="ts">
import FaceSwapBtn from './FaceSwapBtn.vue';
import FeatureCard from './FeatureCard.vue';

const { t } = useI18n();
</script>
